<template>
    <div class="dashboard_classification">
        <div class="main_div">
            <div class="headerTop pb-2" ref="headerTop">
                <div class="pr-5 pb-0">
                    <NavigationTabs :activeTab="activeNavTab" @change="(tab) => activeNavTab = tab" />
                </div>
            </div>

            <div class="tab_content">
                <ResultadosTab v-if="activeNavTab === 'resultados'" />
                <VentasTab v-else-if="activeNavTab === 'ventas'" />
                <CostosTab v-else-if="activeNavTab === 'costos'" />
                <GastosTab v-else-if="activeNavTab === 'gastos'" />
                <div v-else class="p-5">
                    <h2 class="title is-4">{{ activeNavTabLabel }}</h2>
                    <p>Contenido para {{ activeNavTabLabel }} en desarrollo.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NavigationTabs from "@/components/generics/NavigationTabs.vue";
import ResultadosTab from "./financialReports/tabs/ResultadosTab.vue";
import VentasTab from "./financialReports/tabs/VentasTab.vue";
import CostosTab from "./financialReports/tabs/CostosTab.vue";
import GastosTab from "./financialReports/tabs/GastosTab.vue";

export default {
    name: "DashboardReports",
    components: {
        NavigationTabs,
        ResultadosTab,
        VentasTab,
        CostosTab,
        GastosTab
    },
    data() {
        return {
            activeNavTab: 'resultados',
            stickyResizeObserver: null,
        };
    },
    computed: {
        activeNavTabLabel() {
            const labels = {
                resultados: 'Resultados',
                ventas: 'Ventas',
                costos: 'Costos',
                gastos: 'Gastos',
                rentabilidad: 'Rentabilidad',
                no_oper: 'No Oper',
                activos: 'Activos'
            };
            return labels[this.activeNavTab] || this.activeNavTab;
        }
    },
    mounted() {
        // nextTick → primer measure tras layout final (no en pleno mount).
        this.$nextTick(() => {
            this.updateTabStickyTop();
            if (typeof ResizeObserver !== 'undefined' && this.$refs.headerTop) {
                this.stickyResizeObserver = new ResizeObserver(this.updateTabStickyTop);
                this.stickyResizeObserver.observe(this.$refs.headerTop);
            }
        });
        // Red de seguridad por si ResizeObserver no atrapa una transición.
        window.addEventListener('resize', this.updateTabStickyTop);
    },
    beforeDestroy() {
        if (this.stickyResizeObserver) {
            this.stickyResizeObserver.disconnect();
        }
        window.removeEventListener('resize', this.updateTabStickyTop);
        document.documentElement.style.removeProperty('--tab-sticky-top');
    },
    methods: {
        // Publica la posición Y donde termina .headerTop cuando está anclado.
        // Los tabs hijos usan esta variable CSS para anclarse justo debajo,
        // sin tener que conocer la altura de la nav ni la del app header global.
        updateTabStickyTop() {
            const el = this.$refs.headerTop;
            if (!el) return;
            const cssTop = parseFloat(getComputedStyle(el).top) || 0;
            // getBoundingClientRect().height conserva precisión sub-pixel,
            // a diferencia de offsetHeight que redondea a entero y deja
            // a las tabs hijas desfasadas por una fracción de pixel.
            const stickyBottom = cssTop + el.getBoundingClientRect().height;
            document.documentElement.style.setProperty(
                '--tab-sticky-top',
                `${stickyBottom}px`
            );
        },
    },
};
</script>

<style lang="scss" scoped>
* {
    font-family: Inter;
}

.headerTop {
    position: sticky;
    // --app-header-bottom lo publica Dashboard.vue midiendo el alto real del
    // header global con ResizeObserver. Fallback 110px para el caso degradado
    // (si por algún motivo Dashboard no publica la variable).
    top: var(--app-header-bottom, 110px);
    width: 100%;
    background-color: white;
    z-index: 5;
    border-bottom: 1px solid #EAECF0;
}

.main_div {
    padding-left: clamp(10px, 5.5vw, 90px);
    padding-right: clamp(10px, 5.5vw, 93px);
    padding-bottom: 30px;
}

.tab_content {
    min-height: 400px;
}
</style>
